import styled, { CSSObject } from "styled-components";
import {
  buttonDarkTheme,
  buttonDefaultTheme,
  IButtonStyleConfig,
} from "../../Foundation/Button/Button.styles";
import { useTheme } from "../../Themes/defaultTheme";
import { hexToRGB } from "../../Utils/font";
import { IArrowNavigationProps } from "./ArrowNavigation";

interface ArrowNavigationAnchorProps extends IArrowNavigationProps {
  $disabled?: boolean;
}

export const ArrowNavigationAnchor = styled.a<ArrowNavigationAnchorProps>(
  ({ direction = "left", mode = "light", $disabled }) => {
    const {
      color: { white, greyText },
    } = useTheme();
    const {
      mono_dark: monoDarkButtonConfig,
      mono_light: monoLightButtonConfig,
    } = buttonDarkTheme.ctaBtn;

    const anchorMode: Record<
      NonNullable<ArrowNavigationAnchorProps["mode"]>,
      IButtonStyleConfig
    > = {
      light: {
        ...monoDarkButtonConfig,
        color: "#020202",
        background: "transparent",
        border: hexToRGB(greyText, 0.3),
      },
      dark: {
        ...monoLightButtonConfig,
        color: white,
        background: "transparent",
        border: hexToRGB(white, 0.3),
      },
    };

    const {
      color,
      background,
      border,
      hoverColor,
      hoverBorder,
      hoverBg,
      activeBg,
      activeBorder,
    } = anchorMode[mode || "light"];

    return {
      opacity: $disabled ? 0.5 : 1,
      pointerEvents: $disabled ? "none" : "all",
      boxSizing: "border-box",
      border: `1px solid ${border}`,
      borderRadius: 48,
      width: 48,
      height: 22,
      background: background,
      display: "inline-flex",
      alignItems: "center",
      padding: "1px 6px",
      justifyContent: direction === "left" ? "flex-start" : "flex-end",
      cursor: $disabled ? "not-allowed" : "pointer",

      ["&:hover, &.hover"]: {
        background: hoverBg,
        borderColor: hoverBorder,
        ["& .arrow-icon"]: {
          color: hoverColor,
          lineHeight: "22px",
        },
      },

      ["& .arrow-icon"]: {
        color: color,
        lineHeight: "22px",
      },
    };
  }
);
